<template>
  <wrld-box :headerTitle="$t('overview')">
    <template v-slot:boxContent>
      <v-container class="pa-4">
        <v-row>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{ $t('fleet.name') }}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{ vehicleOverview.name }}</span>
          </v-col>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{ $t('fleet.licence_plate') }}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{ vehicleOverview.licence_plate | licensePlateValue }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{ $t('fleet.owner') }}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{ vehicleOverview.owner }}</span>
          </v-col>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{ $t('fleet.allowed_countries') }}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <v-chip
              label
              small
              color="accent"
              text-color="white"
              v-for="(allowed_country, i) in vehicleOverview.allowed_countries"
              :key="i"
            >
              <v-icon left small>label</v-icon>
              {{ allowed_country }}
            </v-chip>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{ $t('fleet.cost') }}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <span class="subheading">{{ vehicleOverview.costs.price_per_km }} EUR/KM</span>
          </v-col>
          <v-col class="text-right">
            <span class="subheading">
              <strong>{{ $t('fleet.groups') }}</strong>
            </span>
          </v-col>
          <v-col offset-sm="1">
            <v-chip
              label
              small
              color="accent"
              text-color="white"
              v-for="(group, i) in ['Rozvoz A']"
              :key="i"
            >
              <v-icon left small>label</v-icon>{{ group }}
            </v-chip>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </wrld-box>
</template>

<script>
export default {
  name: 'VehicleDetailOverview',
  props: {
    vehicleOverview: Object
  }
}
</script>
